<template>
  <dl>
    <template v-if="!detailsOnly">
      <dt>{{ $t("components.loanable.description_list.vehicle_name") }}</dt>
      <dd>
        <router-link v-if="isAdminOfLoanable" :to="`/admin/loanables/${loanable.id}`">
          {{ loanable.name }}
        </router-link>
        <template v-else>
          {{ loanable.name }}
        </template>
      </dd>

      <dt>{{ $t("components.loanable.description_list.owner") }}</dt>
      <dd>
        <router-link v-if="isAdminOfLoanable" :to="`/admin/users/${loanableOwnerUser.id}`">
          {{ loanableOwnerUser.full_name }}
        </router-link>
        <template v-else>
          {{ loanableOwnerUser.full_name }}
        </template>
      </dd>

      <template v-if="loanable.comments">
        <dt>{{ $t("components.loanable.description_list.comments") }}</dt>
        <dd>&laquo;&nbsp;{{ loanable.comments }}&nbsp;&raquo;</dd>
      </template>
    </template>
    <template v-if="loanable.type === 'bike'">
      <dt>{{ $t("loanables.fields.model") | capitalize }}</dt>
      <dd v-if="loanable.details.model">{{ loanable.details.model }}</dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("bikes.fields.bike_type.title") | capitalize }}</dt>
      <dd v-if="loanable.details.bike_type">
        {{ $t(`bikes.fields.bike_type.options.${loanable.details.bike_type}`) | capitalize }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("bikes.fields.size.title") | capitalize }}</dt>
      <dd v-if="loanable.details.size">
        {{ $t(`bikes.fields.size.options.${loanable.details.size}`) | capitalize }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>
    </template>
    <template v-else-if="loanable.type === 'trailer'">
      <dt>{{ $t("trailers.fields.maximum_charge") | capitalize }}</dt>
      <dd v-if="loanable.details.maximum_charge">{{ loanable.details.maximum_charge }}</dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("trailers.fields.dimensions") | capitalize }}</dt>
      <dd v-if="loanable.details.dimensions">{{ loanable.details.dimensions }}</dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>
    </template>
    <template v-else-if="loanable.type === 'car'">
      <dt>{{ $t("cars.fields.brand") | capitalize }}</dt>
      <dd v-if="loanable.details.brand">{{ loanable.details.brand }}</dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("loanables.fields.model") | capitalize }}</dt>
      <dd v-if="loanable.details.model">{{ loanable.details.model }}</dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("cars.fields.year_of_circulation.title") | capitalize }}</dt>
      <dd v-if="loanable.details.year_of_circulation">
        {{ loanable.details.year_of_circulation }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("cars.fields.transmission_mode.title") | capitalize }}</dt>
      <dd v-if="loanable.details.transmission_mode">
        {{
          $t(`cars.fields.transmission_mode.options.${loanable.details.transmission_mode}`)
            | capitalize
        }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("cars.fields.engine.title") | capitalize }}</dt>
      <dd v-if="loanable.details.engine">
        {{ $t(`cars.fields.engine.options.${loanable.details.engine}`) | capitalize }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>

      <dt>{{ $t("cars.fields.papers_location.title") | capitalize }}</dt>
      <dd v-if="loanable.details.papers_location">
        {{
          $t(`cars.fields.papers_location.options.${loanable.details.papers_location}`) | capitalize
        }}
      </dd>
      <dd v-else>{{ $t("components.loanable.description_list.undefined") | capitalize }}</dd>
    </template>
    <template v-if="loanable.details.report">
      <dt>{{ $t(`${loanable.type}s.fields.report`) | capitalize }}</dt>
      <dd>
        <safe-file :file="loanable.details.report">{{
          $t("components.loanable.description_list.report")
        }}</safe-file>
      </dd>
    </template>
  </dl>
</template>

<script>
import SafeFile from "@/components/shared/SafeFile.vue";
import { getOwner, isAdminOfLoanable } from "@/helpers/permissions/loanables";
import { capitalize } from "@/helpers/filters";

export default {
  name: "DescriptionList",
  components: { SafeFile },
  props: {
    loanable: {
      type: Object,
      required: false,
      default: undefined,
    },
    detailsOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAdminOfLoanable() {
      return isAdminOfLoanable(this.$store.state.user, this.loanable);
    },
    loanableOwnerUser() {
      return getOwner(this.loanable);
    },
  },
  methods: { capitalize },
};
</script>

<style lang="scss"></style>
